var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-inner",
      staticStyle: {
        padding: "5px 0",
        width: "fit-content",
        "min-width": "1000px",
        height: "100%"
      }
    },
    [
      _c(
        "div",
        [
          _c("el-card", { staticClass: "section" }, [
            _c(
              "fieldset",
              [
                _c("legend", [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CargoNature")))
                ]),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: !_vm.isEditing,
                      "label-width": "110px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("CargoMsg.Cargo_Name") } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "300px" },
                          attrs: { no: "1" },
                          model: {
                            value: _vm.form.name,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "name", $$v)
                            },
                            expression: "form.name"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("CargoMsg.Cargo_PointsToNote") }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { no: "2" },
                            model: {
                              value: _vm.form.dangerousChemicals,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "dangerousChemicals", $$v)
                              },
                              expression: "form.dangerousChemicals"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { label: true, no: "2_1" } },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Yes")))]
                            ),
                            _c(
                              "el-radio",
                              { attrs: { label: false, no: "2_2" } },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_No")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_HazmatContained")
                        }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { no: "3" },
                            model: {
                              value: _vm.form.special,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "special", $$v)
                              },
                              expression: "form.special"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { label: true, no: "3_1" } },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Yes")))]
                            ),
                            _c(
                              "el-radio",
                              { attrs: { label: false, no: "3_2" } },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_No")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "CargoMsg.Cargo_AverageMonthlyCargoVolume"
                          )
                        }
                      },
                      [
                        _c("el-row", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "font-size": "12px"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_OceanFreight"))
                                )
                              ]),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "padding-left": "20px",
                                    "padding-right": "10px"
                                  }
                                },
                                [_vm._v("FCL")]
                              ),
                              _c("el-input-number", {
                                attrs: {
                                  value:
                                    _vm.form.seaShipmentMonthlyFcl || undefined,
                                  precision: 0,
                                  "controls-position": "right",
                                  min: 0,
                                  max: 999999999999,
                                  no: "4"
                                },
                                on: {
                                  input: function(val) {
                                    _vm.form.seaShipmentMonthlyFcl = val
                                  }
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "padding-left": "10px",
                                    "padding-right": "20px"
                                  }
                                },
                                [_vm._v("TEU")]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "padding-right": "10px" } },
                                [_vm._v("LCL")]
                              ),
                              _c("el-input-number", {
                                attrs: {
                                  value:
                                    _vm.form.seaShipmentMonthlyLcl || undefined,
                                  precision: 0,
                                  "controls-position": "right",
                                  min: 0,
                                  max: 999999999999,
                                  no: "5"
                                },
                                on: {
                                  input: function(val) {
                                    _vm.form.seaShipmentMonthlyLcl = val
                                  }
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { "padding-left": "10px" } },
                                [_vm._v("CBM")]
                              )
                            ],
                            1
                          )
                        ]),
                        _c("el-row", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "padding-top": "10px",
                                "font-size": "12px"
                              }
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { "padding-right": "20px" } },
                                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Air")))]
                              ),
                              _c("el-input-number", {
                                attrs: {
                                  value:
                                    _vm.form.airlineShipmentMonthlyMt ||
                                    undefined,
                                  precision: 0,
                                  "conttrols-right": true,
                                  "controls-position": "right",
                                  min: 0,
                                  max: 999999999999,
                                  no: "6"
                                },
                                on: {
                                  input: function(val) {
                                    _vm.form.airlineShipmentMonthlyMt = val
                                  }
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { "padding-left": "10px" } },
                                [_vm._v("MT")]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("CargoMsg.Cargo_PeakSeason") } },
                      [
                        _c("el-row", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "padding-left": "15px"
                              }
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "-15px" },
                                  attrs: { no: "7" },
                                  model: {
                                    value: _vm.formDetail.peakSeason1,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formDetail,
                                        "peakSeason1",
                                        $$v
                                      )
                                    },
                                    expression: "formDetail.peakSeason1"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_January"))
                                  )
                                ]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { no: "8" },
                                  model: {
                                    value: _vm.formDetail.peakSeason2,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formDetail,
                                        "peakSeason2",
                                        $$v
                                      )
                                    },
                                    expression: "formDetail.peakSeason2"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_February"))
                                  )
                                ]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { no: "9" },
                                  model: {
                                    value: _vm.formDetail.peakSeason3,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formDetail,
                                        "peakSeason3",
                                        $$v
                                      )
                                    },
                                    expression: "formDetail.peakSeason3"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_March")))]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { no: "10" },
                                  model: {
                                    value: _vm.formDetail.peakSeason4,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formDetail,
                                        "peakSeason4",
                                        $$v
                                      )
                                    },
                                    expression: "formDetail.peakSeason4"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_April")))]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { no: "11" },
                                  model: {
                                    value: _vm.formDetail.peakSeason5,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formDetail,
                                        "peakSeason5",
                                        $$v
                                      )
                                    },
                                    expression: "formDetail.peakSeason5"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_May")))]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { no: "12" },
                                  model: {
                                    value: _vm.formDetail.peakSeason6,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formDetail,
                                        "peakSeason6",
                                        $$v
                                      )
                                    },
                                    expression: "formDetail.peakSeason6"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_June")))]
                              )
                            ],
                            1
                          )
                        ]),
                        _c("el-row", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "padding-left": "15px"
                              }
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "-15px" },
                                  attrs: { no: "13" },
                                  model: {
                                    value: _vm.formDetail.peakSeason7,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formDetail,
                                        "peakSeason7",
                                        $$v
                                      )
                                    },
                                    expression: "formDetail.peakSeason7"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_July")))]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { no: "14" },
                                  model: {
                                    value: _vm.formDetail.peakSeason8,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formDetail,
                                        "peakSeason8",
                                        $$v
                                      )
                                    },
                                    expression: "formDetail.peakSeason8"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_August"))
                                  )
                                ]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { no: "15" },
                                  model: {
                                    value: _vm.formDetail.peakSeason9,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formDetail,
                                        "peakSeason9",
                                        $$v
                                      )
                                    },
                                    expression: "formDetail.peakSeason9"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_September"))
                                  )
                                ]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { no: "16" },
                                  model: {
                                    value: _vm.formDetail.peakSeason10,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formDetail,
                                        "peakSeason10",
                                        $$v
                                      )
                                    },
                                    expression: "formDetail.peakSeason10"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_October"))
                                  )
                                ]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "-7px" },
                                  attrs: { no: "17" },
                                  model: {
                                    value: _vm.formDetail.peakSeason11,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formDetail,
                                        "peakSeason11",
                                        $$v
                                      )
                                    },
                                    expression: "formDetail.peakSeason11"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_November"))
                                  )
                                ]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "-5.5px" },
                                  attrs: { no: "18" },
                                  model: {
                                    value: _vm.formDetail.peakSeason12,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formDetail,
                                        "peakSeason12",
                                        $$v
                                      )
                                    },
                                    expression: "formDetail.peakSeason12"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_December"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("el-card", { staticClass: "section" }, [
            _c(
              "fieldset",
              [
                _c("legend", [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MainLineTransport")))
                ]),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: !_vm.isEditing,
                      "label-width": "110px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "CargoMsg.Cargo_PreferredShippingMethod"
                          )
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "19" },
                            model: {
                              value: _vm.formDetail.chkSeaWay,
                              callback: function($$v) {
                                _vm.$set(_vm.formDetail, "chkSeaWay", $$v)
                              },
                              expression: "formDetail.chkSeaWay"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_OceanFreight"))
                            )
                          ]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "20" },
                            model: {
                              value: _vm.formDetail.chkAirWay,
                              callback: function($$v) {
                                _vm.$set(_vm.formDetail, "chkAirWay", $$v)
                              },
                              expression: "formDetail.chkAirWay"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Air")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "21" },
                            model: {
                              value: _vm.formDetail.chkRailWay,
                              callback: function($$v) {
                                _vm.$set(_vm.formDetail, "chkRailWay", $$v)
                              },
                              expression: "formDetail.chkRailWay"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Railway")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_PreferredShippingRoute")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "500px" },
                          attrs: {
                            "select-type": _vm.basicCacheKeys.basic_data_Region,
                            "custom-label": function(item) {
                              return item.code + "[" + item.name + "]"
                            },
                            "show-custom-label-in-option": true,
                            multiple: true,
                            "callback-method-type": "value",
                            "default-multiple-value":
                              _vm.formDetail.regionCodes,
                            "tag-value": "code",
                            "tag-name": "name",
                            filterable: "",
                            "filter-tag-names": ["code", "name"],
                            no: "22"
                          },
                          on: {
                            parentCallBack: function(value) {
                              return (_vm.formDetail.regionCodes = [].concat(
                                value
                              ))
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_PreferredPortSea")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "500px" },
                          attrs: {
                            "select-type":
                              _vm.basicCacheKeys.basic_data_Seaport,
                            "callback-method-type": "value",
                            multiple: true,
                            "default-multiple-value":
                              _vm.formDetail.seaPortCodes,
                            "tag-value": "code",
                            "tag-name": "englishName",
                            filterable: "",
                            "filter-tag-names": ["englishName"],
                            no: "23"
                          },
                          on: {
                            parentCallBack: function(value) {
                              return (_vm.formDetail.seaPortCodes = [].concat(
                                value
                              ))
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_PreferredAirportAir")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "500px" },
                          attrs: {
                            "select-type":
                              _vm.basicCacheKeys.basic_data_Airport,
                            filterable: "",
                            "callback-method-type": "value",
                            multiple: true,
                            "default-multiple-value":
                              _vm.formDetail.airPortCodes,
                            "tag-value": "code",
                            "tag-name": "englishName",
                            "filter-tag-names": ["code", "englishName"],
                            no: "24"
                          },
                          on: {
                            parentCallBack: function(value) {
                              return (_vm.formDetail.airPortCodes = [].concat(
                                value
                              ))
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_CommonlyUsedTradeTerms")
                        }
                      },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            staticStyle: { width: "1200px" },
                            attrs: { no: "25" },
                            on: { change: _vm.handlerincoTermCodes },
                            model: {
                              value: _vm.incoTermCodes,
                              callback: function($$v) {
                                _vm.incoTermCodes = $$v
                              },
                              expression: "incoTermCodes"
                            }
                          },
                          _vm._l(_vm.incoTerms, function(item) {
                            return _c(
                              "el-checkbox",
                              {
                                key: item.code,
                                attrs: { label: item.code, no: "26" }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      (_vm.isZh ? item.localName : item.name) ||
                                        item.code
                                    ) +
                                    " "
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_PreferredOceanCarrier")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "500px" },
                          attrs: {
                            "select-type":
                              _vm.basicCacheKeys.basic_data_Company,
                            "method-params": { seaCmp: true, active: true },
                            "custom-label": function(item) {
                              return "" + item.chineseName
                            },
                            "show-custom-label-in-option": true,
                            multiple: true,
                            "default-multiple-value":
                              _vm.formDetail.shippingCompanyCodes,
                            "tag-value": "cmpIdx",
                            "tag-name": "chineseName",
                            filterable: "",
                            "filter-tag-names": ["chineseName", "englishName"],
                            no: "27"
                          },
                          on: {
                            parentCallBack: function(item) {
                              return (_vm.formDetail.shippingCompanyCodes = [].concat(
                                item.value
                              ))
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_PreferredAirline")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "500px" },
                          attrs: {
                            "select-type":
                              _vm.basicCacheKeys.basic_data_Company,
                            "method-params": { airCmp: true, active: true },
                            "custom-label": function(item) {
                              return (
                                "[" + item.shortName + "]" + item.chineseName
                              )
                            },
                            "show-custom-label-in-option": true,
                            multiple: true,
                            "default-multiple-value":
                              _vm.formDetail.airlineCompanyCodes,
                            "tag-value": "cmpIdx",
                            "tag-name": "chineseName",
                            filterable: "",
                            "filter-tag-names": [
                              "shortName",
                              "chineseName",
                              "englishName"
                            ],
                            no: "28"
                          },
                          on: {
                            parentCallBack: function(item) {
                              return (_vm.formDetail.airlineCompanyCodes = [].concat(
                                item.value
                              ))
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_PreferredShippingTerms")
                        }
                      },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            staticStyle: { width: "1200px" },
                            attrs: { no: "29" },
                            on: { change: _vm.handlerShipperTermCodes },
                            model: {
                              value: _vm.shipperTermCodes,
                              callback: function($$v) {
                                _vm.shipperTermCodes = $$v
                              },
                              expression: "shipperTermCodes"
                            }
                          },
                          _vm._l(_vm.shippingTerms, function(item) {
                            return _c(
                              "el-checkbox",
                              {
                                key: item.code,
                                attrs: { label: item.code, no: "30" }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      !item.localName
                                        ? !item.name
                                          ? item.code
                                          : item.name
                                        : item.localName
                                    ) +
                                    " "
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("el-card", { staticClass: "section" }, [
            _c(
              "fieldset",
              [
                _c("legend", [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MainLineTransport")))
                ]),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: !_vm.isEditing,
                      "label-width": "110px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_PreferredCustomsBroker")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { no: "31" },
                                model: {
                                  value: _vm.form.customsBrokerType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "customsBrokerType", $$v)
                                  },
                                  expression: "form.customsBrokerType"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      width: "200px",
                                      "padding-top": "7px"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.SelfDeclaration"
                                          ),
                                          no: "32"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_SelfDeclaration"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_PoaCustomsDeclaration"
                                          ),
                                          no: "33"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_PoaCustomsDeclaration"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              staticStyle: {
                                width: "400px",
                                "padding-left": "30px"
                              },
                              attrs: {
                                "select-type":
                                  _vm.basicCacheKeys.basic_data_Company,
                                "data-filter-function": _vm.customsBrokerFilter,
                                "custom-label": _vm.customsBrokerLabel,
                                "show-custom-label-in-option": true,
                                filterable: "",
                                "default-value": _vm.form.customsBrokerId || "",
                                "method-params": {
                                  customsBroker: true,
                                  bookingAgent: true,
                                  active: true
                                },
                                no: "34"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.customsBrokerId = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "CargoMsg.Cargo_PreferredTruckingService"
                          )
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { no: "35" },
                                model: {
                                  value: _vm.form.truckingType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "truckingType", $$v)
                                  },
                                  expression: "form.truckingType"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      width: "200px",
                                      "padding-top": "7px"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_SelfDelivery"
                                          ),
                                          no: "36"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_SelfDelivery"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_LoadingAtFactory"
                                          ),
                                          no: "37"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_LoadingAtFactory"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c("cargo-company-select", {
                              staticStyle: {
                                width: "400px",
                                "padding-left": "30px"
                              },
                              attrs: {
                                "method-params": {
                                  truckCmp: true,
                                  active: true
                                },
                                "default-value": _vm.form.truckingInfoId || "",
                                no: "38"
                              },
                              on: {
                                change: function(p) {
                                  _vm.form.truckingInfoId = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "CargoMsg.Cargo_PreferredAgentAtDestination"
                          )
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "500px" },
                          attrs: {
                            "select-type":
                              _vm.basicCacheKeys.basic_data_Company,
                            "method-params": {
                              overseaAgent: true,
                              active: true
                            },
                            "default-value": _vm.form.overSeaAgentId || "",
                            filterable: "",
                            headers: [_vm.$t("Partners.englishName")],
                            fields: ["englishName"],
                            "tag-name": "englishName",
                            no: "39"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.overSeaAgentId = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("CargoMsg.Cargo_IssueHbl") } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { no: "40" },
                            model: {
                              value: _vm.form.signedHbl,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "signedHbl", $$v)
                              },
                              expression: "form.signedHbl"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { label: true, no: "41" } },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Yes")))]
                            ),
                            _c(
                              "el-radio",
                              { attrs: { label: false, no: "42" } },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_No")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "CargoMsg.Cargo_DocReleaseAgainstPayment"
                          )
                        }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { no: "43" },
                            model: {
                              value: _vm.form.payed,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "payed", $$v)
                              },
                              expression: "form.payed"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { label: true, no: "44" } },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Yes")))]
                            ),
                            _c(
                              "el-radio",
                              { attrs: { label: false, no: "45" } },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_No")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "500px" },
                          attrs: { type: "textarea", rows: 4, no: "46" },
                          model: {
                            value: _vm.form.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "remarks", $$v)
                            },
                            expression: "form.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }